import { render, staticRenderFns } from "./ExtratoAba.vue?vue&type=template&id=201645d3&scoped=true"
import script from "./ExtratoAba.vue?vue&type=script&lang=js"
export * from "./ExtratoAba.vue?vue&type=script&lang=js"
import style0 from "./ExtratoAba.vue?vue&type=style&index=0&id=201645d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201645d3",
  null
  
)

export default component.exports